import type { Key9Result } from '../types/puzzle';

export const KEY9_DIGITS = [1, 2, 3, 4, 5, 6, 7, 8, 9] as const;

export function normalizeKey9SolvedDigits(value: unknown, status?: Key9Result['status']): number[] {
  if (status && status !== 'missed') return [...KEY9_DIGITS];
  if (!Array.isArray(value)) return [];

  return Array.from(new Set(value
    .map((digit) => Math.floor(Number(digit)))
    .filter((digit) => Number.isInteger(digit) && digit >= 1 && digit <= 9)))
    .sort((a, b) => a - b);
}

export function normalizeKey9Result(result: Key9Result): Key9Result {
  return {
    ...result,
    key9SolvedDigits: normalizeKey9SolvedDigits(result.key9SolvedDigits, result.status)
  };
}

export function collectKey9SolvedDigits(lockedCells: Map<number, number>): number[] {
  return normalizeKey9SolvedDigits(Array.from(lockedCells.values()));
}
